import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'rolePermissions';
export const rolePermissionsActions = makeActions(
  MODEL_NAME,
  'id',
  'role-permissions',
);

export const getAllRolePermissions = rolePermissionsActions.getAll;
export const editRolePermissions = rolePermissionsActions.edit;
export const createRolePermissions = rolePermissionsActions.create;
export const getByIdRolePermissions = rolePermissionsActions.getDataById;
